module.exports = __webpack_public_path__ + "images/5b3d3f56028a125e6320d52911a70b3e-MSW_LineArt_PanelSwap_FPHub-IQ4H_Slide5.png";